import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const datetime = this.element.dataset.datetime
    if (!datetime) return
    
    const date = new Date(datetime)
    
    // Format: "September 12, 2025 at 10:11 PM"
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }
    
    const formatted = date.toLocaleDateString('en-US', options)
    // Convert the format to match Rails' strftime output
    const parts = formatted.split(', ')
    if (parts.length === 2) {
      // Add "at" between date and time
      const timePart = parts[1]
      this.element.textContent = `${parts[0]}, ${timePart.replace(' ', ' at ')}`
    } else {
      this.element.textContent = formatted
    }
  }
}